import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { createPinia } from 'pinia'
import VueCookies from 'vue-cookies'
import axios from 'axios'



var app=createApp(App)


// app.config.globalProperties.$cookies = VueCookies



app.directive('focus', {
    // 当被绑定的元素挂载到 DOM 中时……
    mounted(el) {
      // 聚焦元素
      el.focus()
    }
})


//响应拦截器
axios.interceptors.response.use(response => {
  // const setCookie = response;
  // console.log('拿到cookie')
  // console.log(setCookie)
  // if (setCookie) {
  //   // 处理多个Set-Cookie头部
  //   document.cookie = setCookie.join('; ');
  // }
  // console.log('返回！！！！')
  // console.log(response.data.msg.code)

  if(response.data.msg.code!=0){
    if(response.data.msg.code==401){
      // H5 填写页是免登录页面，不能被全局 401 踢到登录页
      if (window.location.pathname.indexOf('/h5/') !== 0) {
        router.push({ path: '/login' })
        $cookies.set("fanstoken", '')
      }
      // $cookies.set("fansavatar", '')
      // $cookies.set("fansusername", '')
      // $cookies.set("fanscorpId", '')
      // $cookies.set("fanscorpname",'' )
      // $cookies.set("fanscorpphone",'')
    }
    ElMessage.error(response.data.msg.info)
   
  }
  return response
}, error => {
  
  console.log('报错！！！')
  console.log(error.response.data)
  if(error.response.data.msg.code==401){
    //重新登录
    // window.open(window.location.protocol + '//' + window.location.host, "_self")

    // H5 填写页是免登录页面，不能被全局 401 踢到登录页
    if (window.location.pathname.indexOf('/h5/') !== 0) {
      router.push({ path: '/login' })
      $cookies.set("fanstoken", '')
    }
    // $cookies.set("fansavatar", '')
    // $cookies.set("fansusername", '')
    // $cookies.set("fanscorpId", '')
    // $cookies.set("fanscorpname",'' )
    // $cookies.set("fanscorpphone",'')
  }
  ElMessage.error(error.response.data.msg.info)
  return Promise.resolve(error.response)
})


//请求添加cookie
// axios.interceptors.request.use(config => {
//   const cookies = document.cookie;
//   console.log('cookies----')
//   console.log(cookies)
//   if (cookies) {
//     config.headers.Cookie = cookies;
//   }
//   return config;
// });
 
if (process.env.NODE_ENV === "development") {
	// app.config.globalProperties.$url = "/api"
  // 测试
  // app.provide('_url','http://dev.91fen.vip')
  // app.provide('_url2','http://dev.91fen.vip:8181')

  //正式
    // app.provide('_url','http://91fen.vip')
    // app.provide('_url2','http://91fen.vip:8181')
    // app.provide('_urlfile','http://91fen.vip:15086/fileUpload')
    
    // app.config.globalProperties._url='/api'
    // app.config.globalProperties.$systemId = "10"

  //新版
    // app.provide('_urlnew','http://fans.gantanhaokeji.top')

  
}
if (process.env.NODE_ENV === "test") {
	// Vue.prototype.url = '/api2'
    // console.log('test')
    // app.provide('_url','http://dev.91fen.vip')
    // app.provide('_url2','http://dev.91fen.vip:8181')
    // app.provide('_urlfile','http://91fen.vip:15086/fileUpload')
} 
if (process.env.NODE_ENV === "production") {
	// Vue.prototype.url = '/api3'
    // console.log('production')
    // app.provide('_url','http://118.190.98.243')
    // app.provide('_url2','http://118.190.98.243:8181')
    // app.provide('_urlfile','http://91fen.vip:15086/fileUpload')

    //test
    // app.provide('_url','http://127.0.0.1:81/api')
    // app.provide('_url2','http://127.0.0.1:81/api')
    // app.provide('_urlfile','http://91fen.vip:15086/fileUpload')

}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(createPinia()).use(router).use(ElementPlus, {
    locale: zhCn,
  }).mount('#app')


